import './About.css';

function About() {
  return (
    <div className="container">
        <div className="content" style={{maxWidth: 380, width: '100%'}}>
          <img src="imgs/me.jpg" alt="me" height="130" width="130" style={{borderRadius: "50%"}}></img>
          <h1>About</h1>
          <p>Currently living in London and working as Senior Data Engineer at <a href="https://www.primer.io">Primer</a>.</p>
          <p>I was born in the Philippines but mostly grew up in Ireland and studied computer science at <a href="https://www.setu.ie/">Waterford Institute of Technology</a>.</p>
          <p>I have previously worked at <a href="https://www.withintelligence.com">With Intelligence</a>, <a href="https://www.checkout.com/">Checkout</a>, <a href="https://www.ipsos.com/en-uk">Ipsos</a>, <a href="https://www.distilled.ie/">Distilled</a>, and <a href="https://www.donedeal.ie">DoneDeal</a>.</p>
          <p>Find me at <a href="https://twitter.com/jkrclaro">twitter</a>, <a href="https://github.com/jkrclaro">github</a>, and <a href="https://linkedin.com/in/johnclaro">linkedin</a>.</p>
          <h1>Projects</h1>
          <ul>
            <li style={{marginRight: 10}}><a href="/pace">Pace</a> - Convert paces in KMs to Miles</li>
          </ul>
        </div>
    </div>
  );
}

export default About;
